import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";
import { Badge } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { Intent } from "app/pages/website-analysis/traffic-sources/search/common/intent.configuration";
import {
    INTENT_CELL_REPRESENTATION,
    INTENT_PAYLOAD_VALUE,
    MAP_INTENT_PAYLOAD_TO_INTENT_TOOLTIP_DISCLAIMER,
    MAP_INTENT_TO_CHIPDOWN_TEXT,
} from "app/pages/website-analysis/traffic-sources/search/common/intent.configuration";

interface IIntentTooltip {
    keyword: string;
    intentType: Intent;
}

export const IntentTooltip = ({ keyword, intentType }: IIntentTooltip) => {
    const intentTypeToShorthand = INTENT_CELL_REPRESENTATION[intentType];
    return (
        <Flex flexDirection="column">
            <Text
                as="div"
                fontVariant="subtitle1"
                color={colorsPalettes.carbon[500]}
                margin="0 0 4px"
            >
                {translate("keyword.analysis.overview.page.v2.intent.tooltip.title", { keyword })}
            </Text>
            <Flex
                gap="8px"
                margin="16px 0 8px"
            >
                <Badge type="custom" bgColor={colorsPalettes.carbon[25]} color={colorsPalettes.carbon[400]}>
                    {intentTypeToShorthand}
                </Badge>
                <Text
                    as="div"
                    fontVariant="subtitle2"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate("keyword.analysis.overview.page.v2.intent.tooltip.subtitle", {
                        intentType: MAP_INTENT_TO_CHIPDOWN_TEXT[intentType],
                    })}
                </Text>
            </Flex>
            <Text
                as="div"
                fontVariant="caption"
                color={colorsPalettes.carbon[400]}
            >
                {MAP_INTENT_PAYLOAD_TO_INTENT_TOOLTIP_DISCLAIMER[INTENT_PAYLOAD_VALUE[intentType]]}
            </Text>
        </Flex>
    );
};
